































import {
  EstimateTemplate,
  getEstimateTemplates,
  deleteEstimateTemplate
} from "@/api/estimate-templates-api";
import { Component, Vue } from "vue-property-decorator";

@Component({ components: {} })
export default class EstimateTemplateListPage extends Vue {
  fields = [
    {
      key: "title",
      label: "見積テンプレート名"
    },
    { key: "actions", label: " " }
  ];

  estimateTemplates: EstimateTemplate[] = [];

  get items() {
    return this.estimateTemplates.map(template => ({
      id: template.id,
      title: template.title
    }));
  }

  created() {
    this.initEstimateTemplates();
  }

  async initEstimateTemplates() {
    this.estimateTemplates = await getEstimateTemplates();
  }

  async destroy(id: string) {
    // TODO: 可能なら削除する項目の名前を表示
    if (!confirm("本当に削除してもよろしいですか？")) return;
    await deleteEstimateTemplate(id);
    this.initEstimateTemplates();
  }
}
